import React, { useState, useEffect } from "react";
import axios from "axios";
import BlogPost from "./BlogPost";

const BlogPosts = ({ className }) => {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchPosts = async () => {
            try {
                const response = await axios.get("/api/blog/public");
                setPosts(response.data);
            } catch (error) {
                console.error("Error fetching blog posts:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchPosts();
    }, []);

    if (loading) {
        return <p>Loading blog posts...</p>;
    }

    if (posts.length === 0) {
        return <p>No blog posts available.</p>;
    }

    return (
        <div className={className}>
            {posts.map((post) => (
                <BlogPost
                    key={post._id}
                    title={post.title}
                    content={post.content}
                    author={post.author}
                    createdAt={post.createdAt}
                    slug={post.slug}
                />
            ))}
        </div>
    );
};

export default BlogPosts;
